import { CardData } from '../types';

/**
 * Exporta os cards para Excel
 */
export const exportCardsToExcel = async (
  cards: CardData[],
  projectName: string = 'Workflow'
): Promise<void> => {
  try {
    // Importar XLSX dinamicamente
    const XLSX = await import('xlsx');
    const { utils, writeFile } = XLSX;

    // Filtrar apenas cards de atividade (não incluir card inicial ou removidos)
    const activeCards = cards.filter(
      card => card.tipo === 'atividade' && card.status !== 'removido'
    );

    // Preparar dados para a planilha
    // Ordenar por numeroSequencial para manter ordem lógica na exportação
    const sortedCards = [...activeCards].sort((a, b) => {
      const numA = a.numeroSequencial ?? 0;
      const numB = b.numeroSequencial ?? 0;
      return numA - numB;
    });
    
    const excelData = sortedCards.map((card) => {
      // Encontrar próximo card (primeira conexão)
      const nextCardId = card.conexoes_saida.find(c => c.sourceHandle === 'right')?.targetId || '';
      const nextCard = cards.find(c => c.id === nextCardId);
      
      return {
        ID: card.numeroSequencial ?? '', // Chave primária: número sequencial
        id: card.id, // ID interno mantido para referência
        atividade: card.atividade || '',
        responsavel: card.responsavel || '',
        sistema: card.sistema || '',
        pessoasSimultaneas: card.pessoasSimultaneas || 1,
        pessoasSetor: card.pessoasSetor || 1,
        disponibilidade: card.disponibilidade || 100,
        tp: card.lt || 0, // Lead Time (TP)
        tra: card.tt || 0, // Touch Time (TRA)
        tipo_atividade: card.tipo_atividade || '',
        proximoId: nextCardId || '',
        proximoCard: nextCard?.atividade || '',
        posicao_x: card.posicao.x || 0,
        posicao_y: card.posicao.y || 0,
      };
    });

    // Criar workbook
    const worksheet = utils.json_to_sheet(excelData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Fluxo');

    // Ajustar largura das colunas
    const colWidths = [
      { wch: 10 }, // ID (numeroSequencial - chave primária)
      { wch: 10 }, // id (ID interno)
      { wch: 30 }, // atividade
      { wch: 20 }, // responsavel
      { wch: 20 }, // sistema
      { wch: 10 }, // pessoasSimultaneas
      { wch: 10 }, // pessoasSetor
      { wch: 10 }, // disponibilidade
      { wch: 10 }, // tp
      { wch: 10 }, // tra
      { wch: 10 }, // tipo_atividade
      { wch: 10 }, // proximoId
      { wch: 30 }, // proximoCard
      { wch: 10 }, // posicao_x
      { wch: 10 }, // posicao_y
    ];
    worksheet['!cols'] = colWidths;

    // Adicionar cabeçalho com informações do projeto
    const headerData = [
      { A: 'Projeto', B: projectName },
      { A: 'Data Exportação', B: new Date().toLocaleString('pt-BR') },
      { A: '', B: '' }, // Linha em branco
    ];
    
    // Criar sheet de informações se necessário
    const infoSheet = utils.json_to_sheet(headerData);
    utils.book_append_sheet(workbook, infoSheet, 'Informações');

    // Salvar arquivo (remover caracteres especiais do nome)
    const sanitizedName = projectName.replace(/[^a-z0-9]/gi, '_');
    const fileName = `${sanitizedName}_${new Date().toISOString().split('T')[0]}.xlsx`;
    writeFile(workbook, fileName);
  } catch (error) {
    console.error('Erro ao exportar Excel:', error);
    throw new Error('Falha ao exportar Excel. Tente novamente.');
  }
};

